// src/components/kioskPhotos/cropMath.js
//
// The cropper's geometry, kept apart so it is testable without a canvas.
// The frame is the kiosk screen (800x480); the image is scaled by `zoom`
// (1 = just covers the frame) and moved by an offset in frame pixels,
// always clamped so the frame stays fully covered.
export const FRAME_W = 800;
export const FRAME_H = 480;

/** The scale at which the image just covers the frame. */
export const coverScale = (imgW, imgH) => Math.max(FRAME_W / imgW, FRAME_H / imgH);

/** Offset (top-left of the scaled image, in frame px) clamped so no gap shows. */
export function clampOffset(x, y, imgW, imgH, scale) {
  const w = imgW * scale;
  const h = imgH * scale;
  return {
    x: Math.min(0, Math.max(FRAME_W - w, x)),
    y: Math.min(0, Math.max(FRAME_H - h, y)),
  };
}

/** Centred offset for a scale. */
export const centredOffset = (imgW, imgH, scale) => ({ x: (FRAME_W - imgW * scale) / 2, y: (FRAME_H - imgH * scale) / 2 });

/** Keeps the frame's centre on the same image point when the scale changes. */
export function rescaleOffset(off, oldScale, newScale, imgW, imgH) {
  const cx = (FRAME_W / 2 - off.x) / oldScale;
  const cy = (FRAME_H / 2 - off.y) / oldScale;
  return clampOffset(FRAME_W / 2 - cx * newScale, FRAME_H / 2 - cy * newScale, imgW, imgH, newScale);
}
